"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationCodeType = exports.UserRoleType = exports.UserRoleStatus = exports.UserIdentifierType = exports.UserActivityInterval = exports.UnlockResult = exports.UnlockMethod = exports.UnitOccupancy = exports.TimetableRuleType = exports.TimetableRuleState = exports.TicketType = exports.TicketStatus = exports.SmartLockLogType = exports.SmartLockLogSeverity = exports.SmartLockLogCategory = exports.SessionType = exports.ScheduleRuleType = exports.ScheduleRuleState = exports.ReaderType = exports.PropertyMapType = exports.OperationType = exports.OperatingSystem = exports.MessageMethod = exports.InvitationTemplate = exports.InputDevice = exports.HubType = exports.HubDeviceType = exports.HubActivationStatus = exports.GpioMode = exports.FailurePlan = exports.CredentialType = exports.AuthMethod = exports.AlertSeverity = exports.AccessPointType = exports.AccessKeyType = exports.AccessKeyActivationStatus = exports.AccessFrequency = void 0;
var AccessFrequency;
(function (AccessFrequency) {
    AccessFrequency["PERMANENT"] = "PERMANENT";
    AccessFrequency["RECURRING"] = "RECURRING";
    AccessFrequency["TEMPORARY"] = "TEMPORARY";
})(AccessFrequency || (exports.AccessFrequency = AccessFrequency = {}));
var AccessKeyActivationStatus;
(function (AccessKeyActivationStatus) {
    AccessKeyActivationStatus["ACTIVATED"] = "ACTIVATED";
    AccessKeyActivationStatus["DEACTIVATED"] = "DEACTIVATED";
    AccessKeyActivationStatus["EXPIRED"] = "EXPIRED";
    AccessKeyActivationStatus["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
    AccessKeyActivationStatus["PENDING_DEACTIVATION"] = "PENDING_DEACTIVATION";
    AccessKeyActivationStatus["REVOKED"] = "REVOKED";
})(AccessKeyActivationStatus || (exports.AccessKeyActivationStatus = AccessKeyActivationStatus = {}));
var AccessKeyType;
(function (AccessKeyType) {
    AccessKeyType["GUEST"] = "GUEST";
    AccessKeyType["RESIDENT"] = "RESIDENT";
    AccessKeyType["STAFF"] = "STAFF";
    AccessKeyType["TESTER"] = "TESTER";
    AccessKeyType["VENDOR"] = "VENDOR";
})(AccessKeyType || (exports.AccessKeyType = AccessKeyType = {}));
var AccessPointType;
(function (AccessPointType) {
    AccessPointType["AMENITY"] = "AMENITY";
    AccessPointType["COMMON_AREA"] = "COMMON_AREA";
    AccessPointType["RESERVATION_ONLY"] = "RESERVATION_ONLY";
    AccessPointType["RESTRICTED_BLACKLIST"] = "RESTRICTED_BLACKLIST";
    AccessPointType["RESTRICTED_WHITELIST"] = "RESTRICTED_WHITELIST";
})(AccessPointType || (exports.AccessPointType = AccessPointType = {}));
var AlertSeverity;
(function (AlertSeverity) {
    AlertSeverity["HIGH"] = "HIGH";
    AlertSeverity["LOW"] = "LOW";
    AlertSeverity["MODERATE"] = "MODERATE";
})(AlertSeverity || (exports.AlertSeverity = AlertSeverity = {}));
var AuthMethod;
(function (AuthMethod) {
    AuthMethod["AUGUST_EMAIL_AND_PASSWORD"] = "AUGUST_EMAIL_AND_PASSWORD";
    AuthMethod["AUGUST_OAUTH"] = "AUGUST_OAUTH";
    AuthMethod["AUGUST_PHONE_NUMBER_AND_EMAIL"] = "AUGUST_PHONE_NUMBER_AND_EMAIL";
    AuthMethod["AUGUST_PHONE_NUMBER_AND_PASSWORD"] = "AUGUST_PHONE_NUMBER_AND_PASSWORD";
    AuthMethod["EMAIL"] = "EMAIL";
    AuthMethod["EMAIL_AND_PASSWORD"] = "EMAIL_AND_PASSWORD";
    AuthMethod["PHONE_NUMBER"] = "PHONE_NUMBER";
    AuthMethod["PHONE_NUMBER_AND_EMAIL"] = "PHONE_NUMBER_AND_EMAIL";
    AuthMethod["PHONE_NUMBER_AND_PASSWORD"] = "PHONE_NUMBER_AND_PASSWORD";
    AuthMethod["SINGLE_SIGN_ON"] = "SINGLE_SIGN_ON";
})(AuthMethod || (exports.AuthMethod = AuthMethod = {}));
var CredentialType;
(function (CredentialType) {
    CredentialType["FOB"] = "FOB";
    CredentialType["MOBILE"] = "MOBILE";
})(CredentialType || (exports.CredentialType = CredentialType = {}));
var FailurePlan;
(function (FailurePlan) {
    FailurePlan["FAIL_SAFE"] = "FAIL_SAFE";
    FailurePlan["FAIL_SECURE"] = "FAIL_SECURE";
})(FailurePlan || (exports.FailurePlan = FailurePlan = {}));
var GpioMode;
(function (GpioMode) {
    GpioMode["INPUT"] = "INPUT";
    GpioMode["OUTPUT"] = "OUTPUT";
})(GpioMode || (exports.GpioMode = GpioMode = {}));
var HubActivationStatus;
(function (HubActivationStatus) {
    HubActivationStatus["ACTIVATED"] = "ACTIVATED";
    HubActivationStatus["DEACTIVATED"] = "DEACTIVATED";
    HubActivationStatus["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
})(HubActivationStatus || (exports.HubActivationStatus = HubActivationStatus = {}));
var HubDeviceType;
(function (HubDeviceType) {
    HubDeviceType["ETHOS_EDGE_READER"] = "ETHOS_EDGE_READER";
    HubDeviceType["ETHOS_EDGE_READER_NC"] = "ETHOS_EDGE_READER_NC";
    HubDeviceType["ETHOS_EDGE_READER_NO"] = "ETHOS_EDGE_READER_NO";
    HubDeviceType["ETHOS_SECURE_SIDE_DEVICE"] = "ETHOS_SECURE_SIDE_DEVICE";
    HubDeviceType["ETHOS_SECURE_SIDE_DEVICE_NC"] = "ETHOS_SECURE_SIDE_DEVICE_NC";
    HubDeviceType["ETHOS_SECURE_SIDE_DEVICE_NO"] = "ETHOS_SECURE_SIDE_DEVICE_NO";
    HubDeviceType["RASPBERRY_PI"] = "RASPBERRY_PI";
})(HubDeviceType || (exports.HubDeviceType = HubDeviceType = {}));
var HubType;
(function (HubType) {
    HubType["EIGHT_CHANNEL"] = "EIGHT_CHANNEL";
    HubType["FOUR_CHANNEL"] = "FOUR_CHANNEL";
    HubType["SIXTEEN_CHANNEL"] = "SIXTEEN_CHANNEL";
})(HubType || (exports.HubType = HubType = {}));
var InputDevice;
(function (InputDevice) {
    InputDevice["AMAZON_KEY"] = "AMAZON_KEY";
    InputDevice["DPS"] = "DPS";
    InputDevice["INTERCOM"] = "INTERCOM";
    InputDevice["OTHER"] = "OTHER";
    InputDevice["REX"] = "REX";
})(InputDevice || (exports.InputDevice = InputDevice = {}));
var InvitationTemplate;
(function (InvitationTemplate) {
    InvitationTemplate["GENERIC_WELCOME"] = "GENERIC_WELCOME";
    InvitationTemplate["UNIT_GUEST"] = "UNIT_GUEST";
    InvitationTemplate["UNREGISTERED_USER"] = "UNREGISTERED_USER";
})(InvitationTemplate || (exports.InvitationTemplate = InvitationTemplate = {}));
var MessageMethod;
(function (MessageMethod) {
    MessageMethod["EMAIL"] = "EMAIL";
    MessageMethod["SMS"] = "SMS";
})(MessageMethod || (exports.MessageMethod = MessageMethod = {}));
var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["ANDROID"] = "ANDROID";
    OperatingSystem["IOS"] = "IOS";
})(OperatingSystem || (exports.OperatingSystem = OperatingSystem = {}));
var OperationType;
(function (OperationType) {
    OperationType["DELETE"] = "DELETE";
    OperationType["INSERT"] = "INSERT";
    OperationType["UPDATE"] = "UPDATE";
})(OperationType || (exports.OperationType = OperationType = {}));
var PropertyMapType;
(function (PropertyMapType) {
    PropertyMapType["ELEVATION"] = "ELEVATION";
    PropertyMapType["FLOOR_PLATE"] = "FLOOR_PLATE";
    PropertyMapType["OBLIQUE"] = "OBLIQUE";
    PropertyMapType["STACK"] = "STACK";
})(PropertyMapType || (exports.PropertyMapType = PropertyMapType = {}));
var ReaderType;
(function (ReaderType) {
    ReaderType["KEYPAD"] = "KEYPAD";
    ReaderType["LONG_RANGE"] = "LONG_RANGE";
    ReaderType["NON_KEYPAD"] = "NON_KEYPAD";
})(ReaderType || (exports.ReaderType = ReaderType = {}));
var ScheduleRuleState;
(function (ScheduleRuleState) {
    ScheduleRuleState["CONTROLLED"] = "CONTROLLED";
    ScheduleRuleState["LOCKDOWN"] = "LOCKDOWN";
    ScheduleRuleState["UNLOCKED"] = "UNLOCKED";
})(ScheduleRuleState || (exports.ScheduleRuleState = ScheduleRuleState = {}));
var ScheduleRuleType;
(function (ScheduleRuleType) {
    ScheduleRuleType["ALLOWANCE"] = "ALLOWANCE";
    ScheduleRuleType["RESTRICTION"] = "RESTRICTION";
})(ScheduleRuleType || (exports.ScheduleRuleType = ScheduleRuleType = {}));
var SessionType;
(function (SessionType) {
    SessionType["ACCESS_APP"] = "ACCESS_APP";
    SessionType["ADMIN_PANEL"] = "ADMIN_PANEL";
})(SessionType || (exports.SessionType = SessionType = {}));
var SmartLockLogCategory;
(function (SmartLockLogCategory) {
    SmartLockLogCategory["GENERAL"] = "GENERAL";
    SmartLockLogCategory["GUEST_MANAGEMENT"] = "GUEST_MANAGEMENT";
    SmartLockLogCategory["LOCK"] = "LOCK";
    SmartLockLogCategory["UNLOCK"] = "UNLOCK";
    SmartLockLogCategory["WORK_ORDER"] = "WORK_ORDER";
})(SmartLockLogCategory || (exports.SmartLockLogCategory = SmartLockLogCategory = {}));
var SmartLockLogSeverity;
(function (SmartLockLogSeverity) {
    SmartLockLogSeverity["ALERT"] = "ALERT";
    SmartLockLogSeverity["CRITICAL"] = "CRITICAL";
    SmartLockLogSeverity["DEBUG"] = "DEBUG";
    SmartLockLogSeverity["EMERGENCY"] = "EMERGENCY";
    SmartLockLogSeverity["ERROR"] = "ERROR";
    SmartLockLogSeverity["INFO"] = "INFO";
    SmartLockLogSeverity["NOTICE"] = "NOTICE";
    SmartLockLogSeverity["WARNING"] = "WARNING";
})(SmartLockLogSeverity || (exports.SmartLockLogSeverity = SmartLockLogSeverity = {}));
var SmartLockLogType;
(function (SmartLockLogType) {
    SmartLockLogType["LOCK_MANUAL"] = "LOCK_MANUAL";
    SmartLockLogType["LOCK_VIA_APP"] = "LOCK_VIA_APP";
    SmartLockLogType["LOCK_VIA_KEYPAD"] = "LOCK_VIA_KEYPAD";
    SmartLockLogType["PIN_CODE_MANAGEMENT_CREATE"] = "PIN_CODE_MANAGEMENT_CREATE";
    SmartLockLogType["PIN_CODE_MANAGEMENT_DELETE"] = "PIN_CODE_MANAGEMENT_DELETE";
    SmartLockLogType["UNLOCK_MANUAL"] = "UNLOCK_MANUAL";
    SmartLockLogType["UNLOCK_VIA_APP"] = "UNLOCK_VIA_APP";
    SmartLockLogType["UNLOCK_VIA_KEYPAD"] = "UNLOCK_VIA_KEYPAD";
    SmartLockLogType["USER_MANAGEMENT_ADD"] = "USER_MANAGEMENT_ADD";
    SmartLockLogType["USER_MANAGEMENT_REMOVE"] = "USER_MANAGEMENT_REMOVE";
})(SmartLockLogType || (exports.SmartLockLogType = SmartLockLogType = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["PENDING"] = "PENDING";
    TicketStatus["SOLVED"] = "SOLVED";
    TicketStatus["UNSOLVED"] = "UNSOLVED";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
var TicketType;
(function (TicketType) {
    TicketType["SMART_LOCK_LOW_BATTERY"] = "SMART_LOCK_LOW_BATTERY";
    TicketType["TURNOVER_LOCK_RESET"] = "TURNOVER_LOCK_RESET";
})(TicketType || (exports.TicketType = TicketType = {}));
var TimetableRuleState;
(function (TimetableRuleState) {
    TimetableRuleState["CONTROLLED"] = "CONTROLLED";
    TimetableRuleState["LOCKDOWN"] = "LOCKDOWN";
    TimetableRuleState["UNLOCKED"] = "UNLOCKED";
})(TimetableRuleState || (exports.TimetableRuleState = TimetableRuleState = {}));
var TimetableRuleType;
(function (TimetableRuleType) {
    TimetableRuleType["ALLOWANCE"] = "ALLOWANCE";
    TimetableRuleType["RESTRICTION"] = "RESTRICTION";
})(TimetableRuleType || (exports.TimetableRuleType = TimetableRuleType = {}));
var UnitOccupancy;
(function (UnitOccupancy) {
    UnitOccupancy["OCCUPIED"] = "OCCUPIED";
    UnitOccupancy["VACANT"] = "VACANT";
})(UnitOccupancy || (exports.UnitOccupancy = UnitOccupancy = {}));
var UnlockMethod;
(function (UnlockMethod) {
    UnlockMethod["ACCESS_APP_FAVORITES"] = "ACCESS_APP_FAVORITES";
    UnlockMethod["ACCESS_APP_NEARBY"] = "ACCESS_APP_NEARBY";
    UnlockMethod["ACCESS_APP_SEARCH"] = "ACCESS_APP_SEARCH";
    UnlockMethod["ACCESS_WEB"] = "ACCESS_WEB";
    UnlockMethod["ADMIN_PANEL"] = "ADMIN_PANEL";
    UnlockMethod["CREDENTIAL_MOBILE"] = "CREDENTIAL_MOBILE";
    UnlockMethod["CREDENTIAL_PHYSICAL"] = "CREDENTIAL_PHYSICAL";
    UnlockMethod["CREDENTIAL_UNKNOWN"] = "CREDENTIAL_UNKNOWN";
    UnlockMethod["FOB"] = "FOB";
    UnlockMethod["INPUT_DEVICE"] = "INPUT_DEVICE";
    UnlockMethod["NFC"] = "NFC";
    UnlockMethod["PIN_CODE"] = "PIN_CODE";
    UnlockMethod["QR_CODE"] = "QR_CODE";
    UnlockMethod["SIRI_SHORTCUT"] = "SIRI_SHORTCUT";
    UnlockMethod["SMART_BUILDING_PORTAL"] = "SMART_BUILDING_PORTAL";
    UnlockMethod["SPACESHIP_MODE"] = "SPACESHIP_MODE";
    UnlockMethod["WIDGET_FAVORITES"] = "WIDGET_FAVORITES";
    UnlockMethod["WIDGET_NEARBY"] = "WIDGET_NEARBY";
})(UnlockMethod || (exports.UnlockMethod = UnlockMethod = {}));
var UnlockResult;
(function (UnlockResult) {
    UnlockResult["ACCESS_DENIED"] = "ACCESS_DENIED";
    UnlockResult["ACCESS_GRANTED"] = "ACCESS_GRANTED";
})(UnlockResult || (exports.UnlockResult = UnlockResult = {}));
var UserActivityInterval;
(function (UserActivityInterval) {
    UserActivityInterval["DAY"] = "DAY";
    UserActivityInterval["HOUR"] = "HOUR";
})(UserActivityInterval || (exports.UserActivityInterval = UserActivityInterval = {}));
var UserIdentifierType;
(function (UserIdentifierType) {
    UserIdentifierType["EMAIL"] = "EMAIL";
    UserIdentifierType["PHONE_NUMBER"] = "PHONE_NUMBER";
})(UserIdentifierType || (exports.UserIdentifierType = UserIdentifierType = {}));
var UserRoleStatus;
(function (UserRoleStatus) {
    UserRoleStatus["ACTIVATED"] = "ACTIVATED";
    UserRoleStatus["ACTIVE"] = "ACTIVE";
    UserRoleStatus["EXPIRED"] = "EXPIRED";
    UserRoleStatus["PENDING"] = "PENDING";
    UserRoleStatus["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
    UserRoleStatus["REVOKED"] = "REVOKED";
})(UserRoleStatus || (exports.UserRoleStatus = UserRoleStatus = {}));
var UserRoleType;
(function (UserRoleType) {
    UserRoleType["ADMIN"] = "ADMIN";
    UserRoleType["CONTACT_CENTER_AGENT"] = "CONTACT_CENTER_AGENT";
    UserRoleType["CONTACT_CENTER_SUPERVISOR"] = "CONTACT_CENTER_SUPERVISOR";
    UserRoleType["INTEGRATOR"] = "INTEGRATOR";
    UserRoleType["MAINTENANCE"] = "MAINTENANCE";
    UserRoleType["PROPERTY_MANAGER"] = "PROPERTY_MANAGER";
    UserRoleType["PROPERTY_SUPPORT"] = "PROPERTY_SUPPORT";
})(UserRoleType || (exports.UserRoleType = UserRoleType = {}));
var VerificationCodeType;
(function (VerificationCodeType) {
    VerificationCodeType["AUGUST_2FA"] = "AUGUST_2FA";
    VerificationCodeType["AUGUST_NEW_FACTOR"] = "AUGUST_NEW_FACTOR";
})(VerificationCodeType || (exports.VerificationCodeType = VerificationCodeType = {}));
//# sourceMappingURL=generated.js.map